import { MChatMember } from './chat-member';
import { MChatMessageAttachment } from './chat-message-attachment';

export type TChatMessageType = 'text' | 'image' | 'video' | 'file';

interface IChatMessageProps {
  id: number;
  type: TChatMessageType;
  content: string | null;
  sender: MChatMember;
  sentAt: Date;
  attachments: MChatMessageAttachment[] | null;
  fromMe: boolean;
}

export class MChatMessage {
  props: IChatMessageProps;

  constructor(props: IChatMessageProps) {
    this.props = props;
  }

  get hasAttachments() {
    return this.props.attachments !== null && this.props.attachments.length > 0;
  }

  get isSentToday() {
    const today = new Date();
    return this.props.sentAt.toDateString() === today.toDateString();
  }
}
